module.exports = __webpack_public_path__ + "media/images/x-2b6be04cdfcef1a1c4b47c07aaee83f2.svg";